import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=568dcfde&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "./Orders.vue?vue&type=style&index=0&id=568dcfde&prod&scoped=true&lang=css"
import style1 from "./Orders.vue?vue&type=style&index=1&id=568dcfde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568dcfde",
  null
  
)

export default component.exports